import {
  Box,
  Button,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from '@mui/material';
import React from 'react';

import ResponsiveDialog from '@/components/ResponsiveDialog';

interface MessageModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  message: string;
  icon?: React.ReactNode;
  iconColor?: string;
}

const MessageModal: React.FC<MessageModalProps> = ({
  open,
  onClose,
  title,
  message,
  icon,
  iconColor,
}) => {
  const theme = useTheme();

  return (
    <ResponsiveDialog
      fullScreenOnMobile={false}
      open={open}
      maxWidth='xs'
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: '8px',
            boxShadow: theme.shadows[24],
          },
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          p: '16px 20px',
          borderBottom: `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          {icon && (
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: iconColor,
              }}
            >
              {icon}
            </Box>
          )}
          <Typography variant='h6'>{title}</Typography>
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          padding: '24px',
        }}
      >
        <Typography
          variant='body1'
          sx={{
            color: theme.palette.text.secondary,
            lineHeight: 1.6,
            marginTop: 2,
            textAlign: 'center',
          }}
        >
          {message}
        </Typography>
        <Button
          fullWidth
          variant='outlined'
          onClick={onClose}
          sx={{ borderRadius: 1, marginTop: 2, textTransform: 'none' }}
        >
          Close
        </Button>
      </DialogContent>
    </ResponsiveDialog>
  );
};

export default MessageModal;
